import React from 'react';
import DateFormatter from './DateFormatter';
import NumericFormatter from './NumericFormatter';
import getFieldType from '../../../utils/getFieldType';
import * as entities from '../../../graphql/entities';

const MultiFormatter = (props) => {
  const { rowData } = props.dependentValues;
  let type;
  if (rowData && rowData.rowType && rowData.toValue) {
    type = props.dependentValues.rowData.rowType;
  } else {
    return <div />;
  }

  switch (getFieldType(props.column.editor.props.importEntity, type)) {
    case 'BigDecimal':
      return <NumericFormatter {...props} align="left" value={rowData.toValue} />;
    case 'Long':
    case 'Integer':
      return <NumericFormatter {...props} type="integer" align="left" value={rowData.toValue} />;
    case 'LocalDateTime':
    case 'LocalDate':
      return <DateFormatter {...props} value={rowData.toValue} />;
    case 'String':
      return <div title={rowData.toValue}>{rowData.toValue}</div>;
    default:
      const entity = entities[getFieldType(props.column.editor.props.importEntity, type)];
      return <div>{rowData.toValue[entity.dropdown.labelKey]}</div>;
  }
};

export default MultiFormatter;
